import { render, staticRenderFns } from "./MobileSelect.vue?vue&type=template&id=fd630cda&scoped=true"
import script from "./MobileSelect.vue?vue&type=script&lang=js"
export * from "./MobileSelect.vue?vue&type=script&lang=js"
import style0 from "./MobileSelect.vue?vue&type=style&index=0&id=fd630cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd630cda",
  null
  
)

export default component.exports